import {Component, Injector, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-date-range-single-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/single-select-search-control.component.html",
    providers: [
        registerSearchControl(DateRangeSingleSelectSearchControlComponent)
    ]
})
export class DateRangeSingleSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> implements OnInit, OnChanges {

    /**
     * Optional filtering based on BI cube
     */
    @Input() cube: string;

    constructor(injector: Injector) {
        super(undefined, injector);
    }

    ngOnInit(): void {
        this.init();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.init();
    }

    private init(): void {
        if (this.cube === "SalesDaily") {
            this.buildData([
                {label: "wbo.common.dateRange.yesterday", value: "yesterday"},

                {label: "wbo.common.dateRange.thisWeek", value: "thisWeek"},
                {label: "wbo.common.dateRange.lastWeek", value: "lastWeek"},
                {label: "wbo.common.dateRange.last7Days", value: "last7Days"},

                {label: "wbo.common.dateRange.thisMonth", value: "thisMonth"},
                {label: "wbo.common.dateRange.lastMonth", value: "lastMonth"},
                {label: "wbo.common.dateRange.last30Days", value: "last30Days"},
                {label: "wbo.common.dateRange.last4Weeks", value: "last4Weeks"}
            ]);
        } else {
            this.buildData([
                {label: "wbo.common.dateRange.last12Hours", value: "last12Hours"},
                {label: "wbo.common.dateRange.last6Hours", value: "last6Hours"},
                {label: "wbo.common.dateRange.today", value: "today"},
                {label: "wbo.common.dateRange.yesterday", value: "yesterday"},

                {label: "wbo.common.dateRange.thisWeek", value: "thisWeek"},
                {label: "wbo.common.dateRange.lastWeek", value: "lastWeek"},
                {label: "wbo.common.dateRange.last7Days", value: "last7Days"},

                {label: "wbo.common.dateRange.thisMonth", value: "thisMonth"},
                {label: "wbo.common.dateRange.lastMonth", value: "lastMonth"},
                {label: "wbo.common.dateRange.last30Days", value: "last30Days"},
                {label: "wbo.common.dateRange.last4Weeks", value: "last4Weeks"},

                {label: "wbo.common.dateRange.thisCalendarQuarter", value: "thisCalendarQuarter"},
                {label: "wbo.common.dateRange.lastCalendarQuarter", value: "lastCalendarQuarter"},
                {label: "wbo.common.dateRange.last90Days", value: "last90Days"},
                {label: "wbo.common.dateRange.last3Months", value: "last3Months"},

                {label: "wbo.common.dateRange.thisCalendarYear", value: "thisCalendarYear"},
                {label: "wbo.common.dateRange.lastCalendarYear", value: "lastCalendarYear"},
                {label: "wbo.common.dateRange.last365Days", value: "last365Days"},
                {label: "wbo.common.dateRange.last12Months", value: "last12Months"}
            ]);

        }
    }
}
